export const CREATE_PURCHASE_BILL = 'CREATE_PURCHASE_BILL';
export const GET_PURCHASE_BILLS = 'GET_PURCHASE_BILLS';
export const GET_PURCHASE_BILLS_PAGE = 'GET_PURCHASE_BILLS_PAGE';
export const PURCHASE_BILL_REQUEST = 'PURCHASE_BILL_REQUEST';
export const PURCHASE_BILL_REQUEST_SUCCESS = 'PURCHASE_BILL_REQUEST_SUCCESS';
export const UPDATE_PURCHASE_BILL = 'UPDATE_PURCHASE_BILL';
export const DELETE_PURCHASE_BILL = 'DELETE_PURCHASE_BILL';
export const PURCHASE_BILL_REQUEST_FAILURE = 'PURCHASE_BILL_REQUEST_FAILURE';
export const GET_AVAILABLE_CHALLANS = 'GET_AVAILABLE_CHALLANS';